import type {FC} from 'react';

export const ForwardThemeWrapper: FC<{
  Component: FC<any>;
  forwardTheme: any;
}> = ({Component, forwardTheme, ...rest}) => {
  return <Component {...rest} forwardTheme={forwardTheme} />;
};

export const ThemeForwardingWrapper: FC<{
  Component: FC<any>;
  forwardTheme: any;
}> = ({Component, forwardTheme, ...rest}) => {
  return <Component {...rest} theme={forwardTheme} />;
};
